import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ['~/scss/variables.scss'],
  treeShake: true,
  breakpoint: {
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1F2022',
        secondary: '#424242',
        accent: '#82B1FF',
        // Semantics are the brand's (docs/brand-style-guide.html).
        error: '#F72C2F',
        info: '#2563EB',
        success: '#16A34A',
        warning: '#D97706',
        // Was indigo #4F46E5, which the brand rules ban. Black, like every other selected state here.
        mcsprimary: '#1F2022',
        light: '#F8F8F8',
        anchor: '#5E2DC1',
        background: '#F2F2F2'
      }
    }
  }
});
